import { Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import WhatsAppFloat from './components/WhatsAppFloat';
import AppDownloadModal from './components/AppDownloadModal';
import React from 'react';
import Home from './pages/Home';
import RoutesPage from './pages/Routes';
import Gallery from './pages/Gallery';
import Contact from './pages/Contact';
import Book from './pages/Book';
import Support from './pages/Support';
import PrivacyPolicy from './pages/PrivacyPolicy';
import Tickets from './pages/Tickets';
import Account from './pages/Account';
import { LanguageProvider } from './contexts/LanguageContext';
import { BookingProvider } from './booking/BookingContext';
import { AuthProvider } from './auth/AuthContext';
import BookingLayout from './booking/BookingLayout';
import TripsPage from './pages/booking/TripsPage';
import SeatsPage from './pages/booking/SeatsPage';
import DetailsPage from './pages/booking/DetailsPage';
import PaymentPage from './pages/booking/PaymentPage';
import TicketPage from './pages/booking/TicketPage';

function App() {
  return (
    <LanguageProvider>
      <AuthProvider>
        <BookingProvider>
          <div className="min-h-screen font-body">
            <Navbar />

            <main>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/routes" element={<RoutesPage />} />
                <Route path="/gallery" element={<Gallery />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/book" element={<Book />} />
                <Route path="/tickets" element={<Tickets />} />
                <Route path="/account" element={<Account />} />
                <Route element={<BookingLayout />}>
                  <Route path="/book/trips" element={<TripsPage />} />
                  <Route path="/book/seats" element={<SeatsPage />} />
                  <Route path="/book/details" element={<DetailsPage />} />
                  <Route path="/book/payment" element={<PaymentPage />} />
                  <Route path="/book/ticket" element={<TicketPage />} />
                </Route>
                <Route path="/support" element={<Support />} />
                <Route path="/privacy-policy" element={<PrivacyPolicy />} />
              </Routes>
            </main>

            <Footer />
            <WhatsAppFloat />
            <AppDownloadModal />
          </div>
        </BookingProvider>
      </AuthProvider>
    </LanguageProvider>
  );
}

export default App;
